import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  connect() {
    console.log("Reviews modal controller connected")
  }

  open(event) {
    event.preventDefault()
    const projectId = event.currentTarget.dataset.projectId
    const url = `/campus/student_projects/${projectId}/project_reviews`

    // Fetch reviews via AJAX
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.html) {
        this.contentTarget.innerHTML = data.html
        this.modalTarget.open()
      } else {
        console.error('No HTML content received')
      }
    })
    .catch(error => {
      console.error('Error fetching reviews:', error)
      alert('Failed to load reviews')
    })
  }

  close(event) {
    event.preventDefault()
    this.modalTarget.close()
  }
}
